import { getDatabase, ref, set } from 'firebase/database'
import _ from 'lodash'
import { getGoogleSheetDataValues } from '../../../../global/common/convert'
import { gEnums, listTypes } from '../../../../global/enums/globalEnums'
import { createRefPath_event } from '../../../../global/firestoreData/appData/appRefPaths'
import { fs_db } from '../../../../global/firestoreData/appData/fsAppData'
import { settingsHelpers } from '../../../../global/viewSettings/helpers/settingsHelpers'
import { propDataOpts } from '../../../../global/viewSettings/settingsProps/settingsAll'
import { matchSequence } from '../../helpers/matchSequence'

const _formProps = () => {
  return [
    { name: 'name', formItemType: gEnums.formItemTypes.text },
    { name: 'tournamentType', formItemType: gEnums.formItemTypes.select, listType: listTypes.sportsTournamentTypes },
    { name: 'startDate', formItemType: gEnums.formItemTypes.date },
    { name: 'startTime', formItemType: gEnums.formItemTypes },
  ]
}

export const tournamentTypes = {
  existingPlayoff: 'existingPlayoff',
  newPlayoff: 'newPlayoff',
  tournament: 'tournament'
}


export const _sportsTournamentModes = {
  newTournament: 'newTournament',
  existingTournament: 'existingTournament',
}

export const _sportsTournamentViewModes = {
  editTournament: 'editTournament',
  editPlayoff: 'editPlayoff',
  viewTournament: 'viewTournament',
}

const rts = {
  handleAmmendPools: 'handleAmmendPools',
  handleCurrentFormData: 'handleCurrentFormData',
  handleInit_sportsTournament: 'handleInit_sportsTournament',
  handleMatchScoreUpdate: 'handleMatchScoreUpdate',
  handleNewTournament: 'handleNewTournament',
  handleRemove_allTeams: 'handleRemove_allTeams',
  handleSelectedMatchInfo: 'handleSelectedMatchInfo',
  handleSelectTournament: 'handleSelectTournament',
  handleSetTournaments: 'handleSetTournaments',
  handleTeams_init: 'handleTeams_init',
  handleTeams_selected: 'handleTeams_selected',
  handleUpdateTournament: 'handleUpdateTournament',
}


export const sportsTournamentReducer = (state, action) => {

  const { type, dispatch } = action
  const {
    pathViews,
    currentFormData,
    selectedTeams,
    selectedMatchInfo,
    currentPools,
    currentTournament,
    tournaments,
    teams,
    results,
  } = state

  const { courtCount, playoffPoolCount, useThirdCourt } = currentFormData ?? {}

  const { handleSetTournaments } = sportsTournamentHandlers(dispatch)

  switch (type) {

    case rts.handleInit_sportsTournament:
      const appFormItems = _.reduce(_formProps(), (acc, value) => {
        // acc[value.name] = settingsHelpers.newPropEditItem(value.name, value.formItemType, value.listType, null, value.opts);
        acc[value.name] = settingsHelpers.newPropObject(value.name, propDataOpts(false, value.formItemType, null, value.opts))
        return acc;
      }, {});

      if (action.tournaments) {
        return { ...state, appFormItems, tournaments: action.tournaments }
      } else {
        getTournaments(pathViews, action.tournamentKey, handleSetTournaments)
        return { ...state, appFormItems }
      }

    case rts.handleNewTournament:
      return { ...state, tournamentMode: action.tournamentMode }

    case rts.handleSetTournaments:
      return { ...state, tournaments: action.tournaments }

    case rts.handleSelectTournament:
      const _t = tournaments && tournaments[action.tournamentKey]
      if (_t) {
        const _teams = teams ? _.cloneDeep(teams) : {}
        if (_t.selectedTeams) {
          _.forEach(_t.selectedTeams, (t, tk) => {
            if (_teams[tk]) {
              _teams[tk]._selected = true
            } else {
              _teams[tk] = t
              _teams[tk]._selected = true
            }
          })
        }
        const tournament_db = getTournamentData_fromDb(_t, action.tournamentKey)
        return {
          ...state,
          ...tournament_db,
        }
      } else {
        return state
      }

    case rts.handleCurrentFormData:
      const { fd } = action
      return { ...state, currentFormData: fd, ...handleAmmendPools(selectedTeams, currentTournament, fd), readyToUpdate: readyToUpdate(state) }

    case rts.handleTeams_init:
      return { ...state, ...ammendTournamentTeams(action.teams) }

    case rts.handleTeams_selected:
      // teams: teams, selectedTeams: _seeded_teams, selected_teams
      const { teams: _teams, selectedTeams: _selectedTeams, selected_teams } = action.fromSort ? ammendTournamentTeams(teams, action.selectedTeams) : ammendTournamentTeams(action.selectedTeams)
      return { ...state, teams: _teams, selectedTeams: _selectedTeams, selected_teams, ...handleAmmendPools(selectedTeams, currentTournament, currentFormData), readyToUpdate: readyToUpdate(state) }

    case rts.handleAmmendPools:
      return { ...state, ...handleAmmendPools(selectedTeams, currentTournament, currentFormData), readyToUpdate: readyToUpdate(state) }

    case rts.handleSetPools:
      return state

    case rts.handleMatchScoreUpdate:
      const { _currentPools, _playoffSeeds, _updatedMatch } = handleMatchScoreUpdate(action.padValue, selectedMatchInfo, currentPools, playoffPoolCount, results)
      updateTournament_results(state, selectedMatchInfo, _updatedMatch)
      return { ...state, currentPools: _currentPools, playoffSeeds: _playoffSeeds, selectedMatchInfo: null, results }

    case rts.handleSelectedMatchInfo:
      return { ...state, selectedMatchInfo: action.matchInfo }

    case rts.handleRemove_allTeams:
      const _ts = _.mapValues(teams, (t) => ({ ...t, _selected: false }))
      return { ...state, selectedTeams: [], selected_teams: {}, teams: _ts }

    case rts.handleUpdateTournament:
      updateTournament_info(state)
      return state

    default:
      return { ...state, selectedMatchInfo: action.matchInfo }
    // nothing
  }
}

export const sportsTournamentHandlers = (dispatch) => {
  return {
    handleAmmendPools: () => { dispatch({ type: rts.handleAmmendPools, dispatch }) },
    handleCurrentFormData: (fd) => { dispatch({ type: rts.handleCurrentFormData, dispatch, fd }) },
    handleInit_sportsTournament: (tournaments, tournamentKey) => { dispatch({ type: rts.handleInit_sportsTournament, dispatch, tournaments, tournamentKey }) },
    handleMatchScoreUpdate: (padValue) => { dispatch({ type: rts.handleMatchScoreUpdate, dispatch, padValue }) },
    handleNewTournament: (tournamentMode) => { dispatch({ type: rts.handleNewTournament, dispatch, tournamentMode }) },
    handleRemove_allTeams: () => { dispatch({ type: rts.handleRemove_allTeams, dispatch }) },
    handleSelectedMatchInfo: (matchInfo) => { dispatch({ type: rts.handleSelectedMatchInfo, dispatch, matchInfo }) },
    handleSelectTournament: (tournamentKey, tournaments_alumni) => { dispatch({ type: rts.handleSelectTournament, dispatch, tournamentKey, tournaments_alumni }) },
    handleSetTournaments: (tournaments) => { dispatch({ type: rts.handleSetTournaments, dispatch, tournaments }) },
    handleTeams_init: (teams) => { dispatch({ type: rts.handleTeams_init, dispatch, teams }) },
    handleTeams_selected: (selectedTeams, fromSort) => { dispatch({ type: rts.handleTeams_selected, dispatch, selectedTeams, fromSort }) },
    handleUpdateTournament: () => { dispatch({ type: rts.handleUpdateTournament, dispatch }) },
  }
}

export const sportsTournamentInitialState = (init_state) => {
  return {
    ...init_state, results: {}, _buttonSize: 'tiny',
    currentFormData: {
      courtCount: 2,
      maxTeams: 8,
      poolCount: 2,
      maxTeamsPerPool: 4,
      roundCount: 1,
      playoffPoolCount: 2,
      playoffTeamCount: 8,
      confinePools: true
    }
  }
};

const updateTournament_results = (state, selectedMatchInfo, _updatedMatch) => {
  const { pathViews, tournamentKey } = state
  const { match } = selectedMatchInfo
  const { poolKey, matchKey, home, away, results } = match
  const { name: name_home } = home
  const { name: name_away } = away
  if (tournamentKey) {
    const subData = ['pools', poolKey, 'matches', matchKey, 'results']
    const refPath = createRefPath_event(pathViews, ['_tournaments_alumni', tournamentKey])
    const refPath_db = createRefPath_event(pathViews, ['_tournaments_alumni', tournamentKey, ...subData])
    const subDtu = _.join(subData, '.');
    const dataToUpdate = {
      [subDtu]: _updatedMatch.results
    }
    console.log('refPath', refPath, dataToUpdate)
    console.log('refPath_db', refPath_db, _updatedMatch.results)
    // database_fns.doc_update(refPath, dataToUpdate, true)
    database_fns.update_docc({
      refPath: refPath,
      data: dataToUpdate,
      allowSet: true,
    })
    updateDatabase(refPath_db, _updatedMatch.results)
    // fn_cls.updateTournamentScore('1wwAHEnbzEczPMqpccM1IlspGqjb91Q5lDco3H4CmlUs', 'Pool Play 4 - Round 1', name_home, name_away, 25, 21, 'set1')
  }

}

const getDb = () => {
  const fs = fs_db.get_fsAlt()
  const { _app } = fs
  try {
    const db = getDatabase(_app);
    return db
  } catch (error) {
    const db = getDatabase();
    return db
  }
}

const updateDatabase = async (refString, updateData) => {
  try {
    const db = getDb()
    await set(ref(db, refString), updateData);
    return { success: true };
  } catch (error) {
    console.log('updateRealtimeScoreToDatabase Error', error);
    return { success: false, error };
  }
};

const updateTournament_info = (state) => {
  const { pathViews, tournamentKey } = state
  const refPath = createRefPath_event(pathViews, ['_tournaments_alumni', tournamentKey ? tournamentKey : database_fns.get_docKey()])
  const dataToUpdate = getTournamentData_fromState(state)
  database_fns.doc_set(refPath, dataToUpdate, false)
}

const getTournaments = (pathViews, tournamentKey, callback) => {
  const cb = (results) => callback(results, tournamentKey)
  const refPath = createRefPath_event(pathViews, ['_tournaments_alumni'])
  database_fns.get_data({ refPath, callback: cb })
}

const readyToUpdate = (state) => {
  const { currentPools, selectedTeams, currentFormData: fd } = state
  const { name, startDate, playoffPoolCount, playoffTeamCount } = fd ?? {}
  let readyToUpdate = false
  if (name && startDate && playoffPoolCount && playoffTeamCount && currentPools && selectedTeams) {
    readyToUpdate = true
  }
  return readyToUpdate
}

const getTournamentData_fromDb = (tournament, tournamentKey) => {

  const { tournamentInfo, pools, teams } = tournament

  return {
    tournamentMode: _sportsTournamentModes.existingTournament,
    currentTournament: tournament,
    tournamentKey: tournamentKey,
    currentFormData: tournamentInfo,
    currentPools: pools,
    selected_teams: teams,
    selectedTeams: _.values(teams),
    teams: teams
  }
}

const getTournamentData_fromState = (state) => {

  const { pathViews, currentPools, selected_teams, currentFormData } = state
  delete currentFormData._deleteProps

  const _tournament = {
    name: currentFormData.name,
    tournamentInfo: { ...currentFormData },
    teams: selected_teams,
    pools: currentPools,
    parentKeys: {
      organizations: pathViews.organizations,
      districts: pathViews.districts,
      sports: pathViews.sports,
    }
  }

  return _tournament
}

const ammendTournamentTeams = (teams, selectedTeams) => {
  if (selectedTeams) {
    // this is a 0-based array
    _.forEach(selectedTeams, (st, index) => {
      st.seed = index + 1
    })
  }
  const _teams_selected = selectedTeams ? selectedTeams : _.filter(teams, { _selected: true })
  const _teamz_selected = _.keyBy(_teams_selected, '_itemKey');
  const _seeded_teams = _teams_selected ? _.sortBy(_teams_selected, [
    (team) => team.seed ?? Infinity, // Use Infinity for teams without seed
    'name',                         // Fallback to name
  ]) : [];
  return { teams: teams, selectedTeams: _seeded_teams, selected_teams: _teamz_selected }
}

function getBestPoolCount(teamCount, courtCount) {

  if (teamCount <= 5) return 1; // Single pool for <= 5 teams

  let poolCount = Math.min(Math.ceil(teamCount / 4), courtCount); // Start with the smallest valid pool count

  while (poolCount > 1) {
    const minTeams = Math.floor(teamCount / poolCount);
    const maxTeams = Math.ceil(teamCount / poolCount);
    const poolsWithMaxTeams = teamCount % poolCount;
    const poolsWithMinTeams = poolCount - poolsWithMaxTeams;

    // Ensure all pools have valid team sizes (3, 4, or 5) and fit within courtCount
    if (minTeams >= 3 && maxTeams <= 5 && poolCount <= courtCount) {
      return poolCount;
    }

    poolCount--;
  }

  // If no valid configuration, default to courtCount with some pools having 5 teams
  return Math.min(courtCount, Math.ceil(teamCount / 5));
}


function ammendCurrentCourtz(pools, currentFormData) {

  const {
    bestFit,
    courtCount,
  } = currentFormData

  if (!bestFit) {

    const _allMatches = {}
    // Step 1: Group matches by round 
    _.forEach(pools, (pool) => {
      _.forEach(pool.matches, (match, matchId) => {
        _allMatches[match._itemKey] = match
      });
    });

    const allMatches_ordered = _.orderBy(_allMatches, ['matchNumber', 'poolKey'])

    let courtNum = 1;
    const matchupSet = new Set();

    _.forEach(allMatches_ordered, (m) => {
      const matchupKey = `${m.home.name}_${m.away.name}`;

      if (!matchupSet.has(matchupKey)) {
        m.courtNumber = courtNum;
        matchupSet.add(matchupKey);
        courtNum++;

        if (courtNum > courtCount) {
          courtNum = 1;
          matchupSet.clear();
        }
      }
    });

    const courts = {}

    const groupedPoolz = _.groupBy(allMatches_ordered, (m) => m.courtNumber);
    _.forEach(groupedPoolz, (gp, gpKey) => {
      courts['court' + gpKey] = { matches: {}, courtNumber: parseInt(gpKey), name: 'court' + parseInt(gpKey) }
      _.forEach(gp, (m, mKey) => {
        courts['court' + gpKey].matches[m._itemKey] = m
      })
    })

    return courts
  }
}


const handleAmmendPools = (selectedTeams, currentTournament, currentFormData) => {

  const {
    bestFit,
    courtCount,
    maxTeams,
    playoffPoolCount,
    poolCount,
    useThirdCourt,
  } = currentFormData

  const { pools: currentPools } = currentTournament ?? {}
  const teamCount = _.size(selectedTeams)
  const _maxCourts = courtCount ? courtCount : 5

  if (currentPools) {
    addName(currentPools)
    const _playoffSeeds = updateTeamRecords(currentPools, playoffPoolCount)
    // assignCourts(currentPools)
    return { _currentPools: currentPools, matchCount: 11, _playoffSeeds }
  }


  const poolCounts = {
    1: [0, 1, 2, 3, 4, 5],
    2: [6, 7, 8],
    3: [9, 10, 11, 12],
    4: [13, 14, 15, 16, 17, 18, 19],
    5: [20],
  }

  let pool_count = parseInt(_.findKey(poolCounts, pc => pc.includes(teamCount)));

  const _poolCounts = {
    bestWithMax: getBestPoolCount(maxTeams, courtCount),
    bestWithCurrent: getBestPoolCount(teamCount, courtCount),
    fromInfo: poolCount
  }

  if (pool_count > _maxCourts) { pool_count = _maxCourts }

  // _poolsMax and _poolsSelected have no matches
  const _poolsMax = createEmptyPoolsFromInfo(currentFormData, bestFit ? _poolCounts.bestWithMax : _poolCounts.fromInfo)
  const _poolsSelected = selectedTeams ? createPools(selectedTeams, _poolCounts) : []

  ammendPoolsMaxWithTeams(_poolsMax, _poolsSelected)

  addName(_poolsMax)

  const matchCount = ammendPoolMatches(_poolsMax)
  const currentCourtz = ammendCurrentCourtz(_poolsMax, currentFormData)
  const currentCourts = ammendCurrentCourts(_poolsMax)
  const missing = filterPools(_poolsMax)
  return { currentPools: _poolsMax, currentCourts, currentCourtz, matchCount }

}

const filterPools = (pools) => {
  const _missingMatches = []
  _.forEach(pools, (pool, poolKey) => {
    const { matches } = pool
    _.forEach(matches, (match, matchKey) => {
      if (_.isEmpty(match.away) || _.isEmpty(match.away)) {
        _missingMatches.push(match)
      }
    })
  })
  return _missingMatches
};

const ammendPoolsMaxWithTeams = (poolsMax, poolsSelected) => {
  _.forEach(poolsMax, (pool_max, cpzKey) => {
    _.forEach(poolsSelected, (pool_selected, cpsKey) => {
      const { teams: teams_max } = pool_max ?? {}
      const { teams: teams } = pool_selected ?? {}
      _.forEach(teams, (team, teamKey) => {
        const { seed } = team ?? {}
        const _team_max = _.find(teams_max, { seed: seed })
        if (_team_max) {
          teams_max[teamKey] = { ...team, index: _team_max.index }
          delete teams_max[_team_max._itemKey]
          // Replace _team with team
        }
      })
    })
  })
}

const ammendCurrentCourts = (currentPools) => {
  const _currentCourts = {}
  const groupedPools = _.groupBy(currentPools, (pool) => pool.courtNumber);
  _.forEach(groupedPools, (groupedPool, index) => {
    _.forEach(groupedPool, (gp) => {
      _currentCourts['court' + gp.courtNumber] = {
        courtNumber: gp.courtNumber,
        name: 'court' + gp.courtNumber,
        matches: gp.matches
      }
    })
  })
  return _currentCourts
}

const addName = (obj) => {
  if (obj) {
    _.forEach(obj, (cp, pk) => {
      cp.name = pk
    })
  }
}


// if (useThirdCourt) {
//   switch (teamCount) {
//     case 11:
//       const _selectedTeams = _.sortBy(selectedTeams, 'seed')
//       const groups = _selectedTeams.reduce(
//         (acc, team, index) => {
//           acc[index % 2 === 0 ? 0 : 1].push(team); // Alternate between Group A (0) and Group B (1)
//           return acc;
//         },
//         [[], []] // Initial structure: [Group A, Group B]
//       );
//       const [groupA, groupB] = groups;
//       const pools = {}
//       const playGrids_5 = sgs.wpial_home_away[5]
//       const playGrids_6 = sgs.wpial_home_away[6]
//       createPools_alt(pools, 'poolA', _.size(groupA) === 5 ? playGrids_5 : playGrids_6, groupA, 0, _.size(groupA) === 6 ? 4 : null)
//       createPools_alt(pools, 'poolB', _.size(groupB) === 5 ? playGrids_5 : playGrids_6, groupB, 0, _.size(groupB) === 6 ? 4 : null)
//       // assignCourts(pools)
//       addName(pools)
//       return { _currentPools: pools, matchCount: 22 }
//   }
// }

const getGsData = (matches) => {

  const _matches = []

  _.forEach(matches, (match) => {
    let m = {
      poolKey: match.poolKey,
      matchNumber: match.matchNumber,
      courtNumber: match.courtNumber,
      timeSlot: match.timeSlot,
      home: match.home.name,
      away: match.away.name,
      work: match.work.name,
    }
    _matches.push(m)
  })

  const headers = ['poolKey', 'timeSpot', 'matchNumber', 'courtNumber', 'home', 'away', 'work']
  const { values } = getGoogleSheetDataValues(_matches, headers, 'Results')


}

const arrayToTsv = (array) => {
  const headers = Object.keys(array[0]); // Get headers from the first object
  const rows = array.map(obj => headers.map(header => obj[header]).join('\t')); // Format each row
  return [headers.join('\t'), ...rows].join('\n'); // Combine headers with rows and add newlines
};

// function createPools_alt(pools, poolKey, playGrids, selectedTeams, startIndex, maxRounds) {

//   const matches = {}
//   const teams = {}

//   let matchCount = 1

//   _.forEach(playGrids, (pg, roundNumber) => {
//     _.forEach(pg, (pgi, matchNumber) => {
//       const { h, a, w } = pgi
//       const _h = selectedTeams[h - 1 + startIndex]
//       const _a = selectedTeams[a - 1 + startIndex]
//       const _w = selectedTeams[w - 1 + startIndex]
//       let allow = true
//       if (maxRounds && parseInt(roundNumber) > maxRounds) {
//         allow = false
//       }
//       if (allow) {
//         const matchKey = 'match' + matchCount
//         matches[matchKey] = {
//           home: _h,
//           away: _a,
//           work: _w,
//           matchKey,
//           matchNumber: matchCount,
//           poolKey,
//           _itemKey: `pool${poolKey}-match${matchKey}`,
//           results: {
//             sets: [
//               { away: 0, home: 0 },
//               { away: 0, home: 0 },
//             ]
//           }
//         }
//         if (!matches[_h._itemKey]) {
//           teams[_h._itemKey] = _h
//         }
//         if (!matches[_a._itemKey]) {
//           teams[_a._itemKey] = _a
//         }
//         matchCount++
//       }
//     })
//   })

//   pools[poolKey] = {
//     matches,
//     teams
//   }

//   // Add a seeds array to each pool 
//   _.forEach(pools, (pool) => {
//     pool.seeds = pool.teams
//       ? Object.values(pool.teams).map(team => team.seed)
//       : [];
//   })

// }

function createEmptyPoolsFromInfo(currentFormData, poolCount) {

  const { maxTeams } = currentFormData ?? {}

  const pools = {}
  let poolIndex = 0;
  let reverseDirection = false;

  // loop 1 to maxTeams
  for (let t = 1; t <= maxTeams; t++) {

    const teamWithSeed = { name: 'Team ' + t, seed: t, _itemKey: '_' + t, temp: true };
    const poolNumber = String.fromCharCode(65 + poolIndex)
    const poolKey = 'pool' + poolNumber

    if (!pools[poolKey]) { pools[poolKey] = { courtNumber: poolIndex + 1 } }
    if (!pools[poolKey].teams) { pools[poolKey].teams = {} }

    pools[poolKey].teams[teamWithSeed._itemKey] = teamWithSeed;
    pools[poolKey].teams[teamWithSeed._itemKey].index = _.size(pools[poolKey].teams)

    // Decide the direction for the next team
    if (!reverseDirection) {
      poolIndex++;
      if (poolIndex === poolCount) {
        poolIndex--;  // Adjust to last pool
        reverseDirection = true;  // Reverse the direction
      }
    } else {
      poolIndex--;
      if (poolIndex === -1) {
        poolIndex = 0;  // Adjust to first pool
        reverseDirection = false;  // Reverse the direction back
      }
    }
  }

  // Add a seeds array to each pool 
  _.forEach(pools, (pool) => {
    pool.seeds = pool.teams
      ? Object.values(pool.teams).map(team => team.seed)
      : [];
  })

  return pools;

}

function createPools(selectedTeams, _poolCounts) {

  const pools = {}

  const { bestWithCurrent: poolCount, bestWithMax: poolCountM, fromInfo } = _poolCounts

  let poolIndex = 0;
  let reverseDirection = false;

  // Iterate through the teams and assign them to pools
  _.forEach(selectedTeams, (selectedTeam, index) => {

    const teamWithSeed = { ...selectedTeam, seed: index + 1 };
    const poolNumber = String.fromCharCode(65 + poolIndex)
    const poolKey = 'pool' + poolNumber

    if (!pools[poolKey]) { pools[poolKey] = { courtNumber: poolIndex + 1 } }
    if (!pools[poolKey].teams) { pools[poolKey].teams = {} }

    pools[poolKey].teams[teamWithSeed._itemKey] = teamWithSeed;
    pools[poolKey].teams[teamWithSeed._itemKey].index = _.size(pools[poolKey].teams)

    // Decide the direction for the next team
    if (!reverseDirection) {
      poolIndex++;
      if (poolIndex === poolCount) {
        poolIndex--;  // Adjust to last pool
        reverseDirection = true;  // Reverse the direction
      }
    } else {
      poolIndex--;
      if (poolIndex === -1) {
        poolIndex = 0;  // Adjust to first pool
        reverseDirection = false;  // Reverse the direction back
      }
    }
  })

  // Add a seeds array to each pool 
  _.forEach(pools, (pool) => {
    pool.seeds = pool.teams
      ? Object.values(pool.teams).map(team => team.seed)
      : [];
  })

  const pools_2 = createPools2(pools)
  return pools;

}

function createPools2(pools) {

  const _pools = {}
  let _reverse = false
  let _result = 1
  let seed = 1

  let _poolIndex = 0

  _.forEach(pools, (pool, poolKey) => {

    if (!_pools[poolKey]) { _pools[poolKey] = {} }
    if (!_pools[poolKey].teams) { _pools[poolKey].teams = {} }

    const { teams } = pool
    let _teamIndex = 1

    _.forEach(teams, (team, teamIndex) => {
      const poolName = String.fromCharCode(65 + _poolIndex)
      _pools[poolKey].teams['team' + _teamIndex] = {
        pending: {
          pool: poolName,
          result: _result,
          seed
        }
      };
      _teamIndex++
      seed++
      if (_reverse) {
        _poolIndex--
      } else {
        _poolIndex++
      }
    })

    if (_reverse) {
      _poolIndex++
    } else {
      _poolIndex--
    }
    _reverse = !_reverse
    _result++
  })

  return _pools;

}

const ammendPoolMatches = (pools) => {

  let matchCount = 0

  _.map(pools, (pool, poolKey) => {

    const { teams } = pool ?? {}

    if (teams) {

      const matches = {}

      const _poolSize = _.size(teams)
      let _matchIndexes = matchSequence.normal[_poolSize]
      if (!_matchIndexes) { _matchIndexes = [] }

      _matchIndexes.map((matchIndex, mi) => {
        const matchNumber = mi + 1
        const matchKey = 'match' + matchNumber
        const _a = _.find(teams, { index: matchIndex[1] })
        const _h = _.find(teams, { index: matchIndex[0] })
        const _w = _.find(teams, { index: matchIndex[2] })
        if (!_a || !_h || _w) {
          // console.log('matchIndex NF', _.size(teams), matchIndex)
        }
        const _away = { ..._a }
        const _home = { ..._h }
        const _work = { ..._w }
        const _match = {
          away: _away,
          home: _home,
          work: _work,
          poolKey,
          matchNumber: matchNumber,
          matchKey: matchKey,
          _itemKey: `pool${poolKey}-match${matchKey}`,
          results: {
            sets: [
              { away: 0, home: 0 },
              { away: 0, home: 0 },
            ]
          }
        }
        matches[matchKey] = _match
      })
      pool.matches = matches
      matchCount += _.size(matches)
    }

  })

  return matchCount
}

const handleMatchScoreUpdate = (padValue, selectedMatchInfo, currentPools, playoffPoolCount, _results) => {
  const _padValue = padValue ? padValue[0] : null
  const { match, setNumber } = selectedMatchInfo
  const { poolKey, matchKey } = match
  const _currentPools = { ...currentPools }
  const _currentPool = _currentPools[poolKey]
  let _updatedMatch;
  if (_currentPool && _padValue) {
    const { matches } = _currentPool
    const _match = matches[matchKey]
    const _padValueS = _padValue.split('-')
    const { results } = _match
    const { sets } = results
    if (sets) {
      sets[setNumber - 1].away = parseInt(_padValueS[0])
      sets[setNumber - 1].home = parseInt(_padValueS[1])
      if (!_results[poolKey]) { _results[poolKey] = {} }
      if (!_results[poolKey][matchKey]) { _results[poolKey][matchKey] = {} }
      if (!_results[poolKey][matchKey].sets) { _results[poolKey][matchKey].sets = {} }
      _results[poolKey][matchKey].sets[setNumber - 1] = sets[setNumber - 1]
      _updatedMatch = _match
    }
  }
  const _playoffSeeds = updateTeamRecords(_currentPools, playoffPoolCount)
  return { _currentPools, _playoffSeeds, _updatedMatch }
}

function updateTeamRecords(pools, playoffPoolCount) {

  const playoffSeeds = []

  _.forEach(pools, (pool) => {

    const { teams, matches, seeds } = pool;

    // Initialize team records with 0 wins and losses directly on the team object
    _.forEach(teams, (team) => {
      team.record = { wins: 0, losses: 0, points: 0 };
    })


    // Process each match
    _.forEach(matches, (match) => {
      const { results } = match
      const { sets } = results
      _.forEach(sets, (set) => {
        const { home: homeScore, away: awayScore } = set;

        if (homeScore > 0 && awayScore > 0) {
          const winner = homeScore > awayScore ? match.home.name : match.away.name;
          const loser = homeScore > awayScore ? match.away.name : match.home.name;
          const pointDifference = Math.abs(homeScore - awayScore);

          // Update the winning team's record
          const winningTeam = _.find(pool.teams, { name: winner });

          if (winningTeam) {
            winningTeam.record.wins += 1;
            winningTeam.record.points += pointDifference;
          }

          // Update the losing team's record
          const losingTeam = _.find(pool.teams, { name: loser });
          if (losingTeam) {
            losingTeam.record.losses += 1;
            losingTeam.record.points -= pointDifference;
          }
        }
      })
    })

    // Sort teams within the pool by wins and points
    const sortedPoolTeams = _.orderBy(teams, ['record.wins', 'record.points'], ['desc', 'desc']);

    if (seeds) {
      _.forEach(sortedPoolTeams, (st, index) => {
        if (index <= (playoffPoolCount - 1)) {
          const _seed = seeds[index]
          playoffSeeds.push({ name: st.name, position: _seed - 1, seed: _seed, _itemKey: st._itemKey })
        }
      })
    }

  });

  return _.sortBy(playoffSeeds, 'seed')
}
